export const ContextMenuSvg = () => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 16.5C8.94772 16.5 8.5 16.0523 8.5 15.5L8.5 14.5C8.5 13.9477 8.94772 13.5 9.5 13.5L10.5 13.5C11.0523 13.5 11.5 13.9477 11.5 14.5L11.5 15.5C11.5 16.0523 11.0523 16.5 10.5 16.5L9.5 16.5ZM9.5 11.5C8.94772 11.5 8.5 11.0523 8.5 10.5L8.5 9.5C8.5 8.94771 8.94771 8.5 9.5 8.5L10.5 8.5C11.0523 8.5 11.5 8.94771 11.5 9.5L11.5 10.5C11.5 11.0523 11.0523 11.5 10.5 11.5L9.5 11.5ZM8.5 5.5C8.5 6.05228 8.94772 6.5 9.5 6.5L10.5 6.5C11.0523 6.5 11.5 6.05229 11.5 5.5L11.5 4.5C11.5 3.94772 11.0523 3.5 10.5 3.5L9.5 3.5C8.94772 3.5 8.5 3.94772 8.5 4.5L8.5 5.5Z"
      fill="#171D23"
    />
  </svg>
);
